import React from 'react';
import PropTypes from 'prop-types';
import NullLoader from './Loader.styled';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

/**
 * A Loader component that provides error handling
 */
const Loader = ({ children, fallback }) => (
  <ErrorBoundary>
    <React.Suspense fallback={fallback}>{children}</React.Suspense>
  </ErrorBoundary>
);
Loader.propTypes = {
  /**
   * Children MUST be a component supplied by React.lazy to leverage lazy loading
   *
   * e.g. const Component = React.lazy(() => import('./Component'));
   *
   * <Loader>
   *  <Component {...props}
   * </Loader>
   */
  children: PropTypes.element.isRequired,
  /**
   * Fallback component
   */
  fallback: PropTypes.element
};

Loader.defaultProps = {
  fallback: <NullLoader />
};

Loader.displayName = 'Loader';

export default Loader;
